export function setAjax(url, datas, type='POST')
{
    return new Promise(function (resolve, reject) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    resolve(xmlhttp);
                } else if(xmlhttp.status === 422){
                    resolve(xmlhttp);
                    let response = JSON.parse(xmlhttp.response);
                    let message = '';
                    for (const resp in response) {
                        message += '<p class="uk-text-small">'+`${response[resp]}`+'</p>';
                    }
                } else if(xmlhttp.status === 403){
                    resolve(xmlhttp);
                    reportFailure(xmlhttp, url);
                    let response = JSON.parse(xmlhttp.response);
                    let message = '';
                    for (const resp in response) {
                        message += '<p class="uk-text-small">'+`${response[resp]}`+'</p>';
                    }
                } else if(xmlhttp.status === 419){
                    reject(xmlhttp);
                    reportFailure(xmlhttp, url);
                }else {
                    reject(xmlhttp);
                    reportFailure(xmlhttp, url);
                }
            }
        }
        xmlhttp.onerror = function (error) {
            reject(error);
        }
        xmlhttp.open(type, url,true);
        xmlhttp.setRequestHeader('Authorization', 'X-CSRF-TOKEN ' + document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
        xmlhttp.setRequestHeader('X-CSRF-TOKEN', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
        xmlhttp.setRequestHeader('X-Requested-With','XMLHttpRequest');
        if(document.querySelector('meta[name="sanT"]') !== null){
            xmlhttp.setRequestHeader('Authorization', 'Bearer ' + document.querySelector('meta[name="sanT"]').getAttribute('content'));
        }
        xmlhttp.send(datas);
    })
}

export function getAjax(url){
    return new Promise(function(resolve, reject){
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function(){
            if(xmlhttp.readyState === 4){
                if(xmlhttp.status === 200){
                    resolve(xmlhttp.responseText);
                } else if(xmlhttp.status === 403){
                    resolve(xmlhttp);
                    let response = JSON.parse(xmlhttp.response);
                    let message = '';
                    for (const resp in response) {
                        message += '<p class="uk-text-small">'+`${response[resp]}`+'</p>';
                    }
                }else if(xmlhttp.status === 419){
                    console.log(xmlhttp.status)
                    // let expSU = document.querySelector('[name="expSU"]');
                    // if( expSU !== null){
                    //     let expSULO = expSU.getAttribute('content')+'LO';
                    //     setAjax(expSULO, null).then((response)=>{
                    //         console.log(response)
                    //     })
                    // setTimeout(()=>{
                    //     location.reload();
                    // }, 800);
                    // }
                }else{
                    reject(xmlhttp);
                }
            }
        }
        xmlhttp.onerror = function(error){
            reject(error);
        }
        xmlhttp.open('GET', url, true);
        xmlhttp.send(null);
    })
}

export function formatBytes(a,b=2) {if(0===a)return"0 Octet";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Octet","Ko","Mo","Go","To","Po","Eo","Zo","Yo"][d]}

export function watchCountMessages(countMessages)
{
    countMessages.forEach(countMessage => {
        let url = countMessage.dataset.r;
        let type = countMessage.dataset.countType
        let status = countMessage.dataset.countStatus
        let datas = new FormData;
        datas.append('type', type);
        datas.append('status', status);
        setAjax(url, datas).then(response=>{
            let json = JSON.parse(response.response);
            if(json.success == 'success') {
                countMessage.innerHTML = parseInt(json.count);
                if(parseInt(json.count) > 0) {
                    countMessage.classList.remove('uk-hidden');
                }
            }
        })
    })
}

export function getMedias(){
    if(document.querySelectorAll('.ltp_btnChooseFile').length !== 0)
    {
        let btnChooseFile = document.querySelectorAll('.ltp_btnChooseFile');
        btnChooseFile.forEach((choice) => {
            choice.addEventListener('click', ()=>{
                let originMediaModal = choice.dataset.origin;
                let originMediaModalRow = choice.dataset.row;
                let originMediaModalSecrow = choice.dataset.secrow;
                if(originMediaModalSecrow !== undefined)
                {
                    originMediaModalSecrow = originMediaModalSecrow
                } else {
                    originMediaModalSecrow = '';
                }

                var r = document.querySelector('#'+originMediaModal+'_'+originMediaModalRow+'_'+originMediaModalSecrow).dataset.r;
                var status = document.querySelector('#'+originMediaModal+'_'+originMediaModalRow+'_'+originMediaModalSecrow).dataset.status;
                var holding = document.querySelector('#'+originMediaModal+'_'+originMediaModalRow+'_'+originMediaModalSecrow).dataset.holding;

                let datas = new FormData();
                datas.set('status', status);
                datas.set('holding', holding);
                datas.set('originMediaModal', originMediaModal);
                setAjax(r,datas).then(function (response) {
                    let json = JSON.parse(response.response)
                    if(json.html !== undefined) {
                        document.querySelector('#'+originMediaModal+'_'+originMediaModalRow+'_'+originMediaModalSecrow+' .ltp_mediasModalContent').innerHTML = json.html;
                        document.querySelector('#ltp_uploadMedia').setAttribute('data-or',originMediaModal);
                        document.querySelector('#ltp_uploadMedia').setAttribute('data-row',originMediaModalRow);
                        if(originMediaModalSecrow!==undefined){
                            document.querySelector('#ltp_uploadMedia').setAttribute('data-secrow',originMediaModalSecrow);
                        }
                    }
                });
            })
        })
    }

    if(document.querySelectorAll('.ltp_iconAddFile').length !== 0) {
        let iconAddFile = document.querySelectorAll('.ltp_iconAddFile');
        iconAddFile.forEach((choice) => {
            choice.addEventListener('click', ()=>{
                let mediaModal = choice.dataset.modal;
                let sortableMediaModal = choice.dataset.sortable;
                let sortableMediaModalRow = choice.dataset.row;
                let sortableMediaModalSecrow = choice.dataset.secrow;
                if(sortableMediaModalSecrow !== undefined)
                {
                    sortableMediaModalSecrow = sortableMediaModalSecrow
                } else {
                    sortableMediaModalSecrow = '';
                }
                var r = document.querySelector('#'+mediaModal+'_'+sortableMediaModalRow+'_'+sortableMediaModalSecrow).dataset.r;
                var status = document.querySelector('#'+mediaModal+'_'+sortableMediaModalRow+'_'+sortableMediaModalSecrow).dataset.status;
                var holding = document.querySelector('#'+mediaModal+'_'+sortableMediaModalRow+'_'+sortableMediaModalSecrow).dataset.holding;

                let datas = new FormData();
                datas.set('status', status);
                datas.set('holding', holding);
                datas.set('originMediaModal', mediaModal);
                setAjax(r,datas).then(function (response) {
                    let json = JSON.parse(response.response)
                    if(json.html != undefined) {
                        document.querySelector('#'+mediaModal+'_'+sortableMediaModalRow+'_'+sortableMediaModalSecrow+' .ltp_mediasModalContent').innerHTML = json.html;
                        document.querySelector('#ltp_uploadMedia').setAttribute('data-or',mediaModal);
                        document.querySelector('#ltp_uploadMedia').setAttribute('data-row',sortableMediaModalRow);
                        if(sortableMediaModalSecrow!=undefined){
                            document.querySelector('#ltp_uploadMedia').setAttribute('data-secrow',sortableMediaModalSecrow);
                        }
                    }
                });
            })
        })
    }

    if(document.querySelectorAll('.ltp_selectMedia').length != 0)
    {
        var buttons = document.querySelectorAll('.ltp_selectMedia');
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                let btnParents = button.offsetParent;
                let origin = btnParents.parentElement.id
                let or_row = origin.split('_')
                let input = or_row[0];
                let row = or_row[1];
                let secrow = '';
                if(or_row.length == 3){
                    secrow = or_row[2]
                }

                let value = btnParents.querySelector('[name="checkedMedia"]:checked').value;
                value = value.split('|');
                let dataType = btnParents.querySelector('[name="checkedMedia"]:checked').dataset.type;



                if(btnParents.parentElement.dataset.origin.length !== 0){

                    let modal = origin;
                    origin = btnParents.parentElement.dataset.origin

                    if(document.querySelector('#'+origin+'_'+row) != null) {
                        let sortableList = document.querySelector('#'+origin+'_'+row);
                        let cardList = '<div class="uk-margin-bottom uk-sortable-handle uk-card uk-card-default uk-card-small uk-margin-right" data-blockid="'+value[0]+'"><div class="uk-float-right uk-margin-small-top uk-margin-small-right uk-text-danger uk-text-center uk-cursor-pointer ltp_trashElement" uk-icon="icon: close"></div><div class="uk-card-body"><figure>';

                        switch (dataType)
                        {
                            case 'video':
                                cardList+='<video src="'+value[1]+'" muted autoplay loop class="uk-responsive-width uk-object-contain uk-align-center" style="width: 200px; height: 200px"></video>';
                                break;
                            case 'pdf':
                                cardList+='<img src="'+value[3]+'" class="uk-responsive-width uk-object-contain uk-align-center" style="width: 200px; height: 200px">';
                                break;
                            default:
                                cardList+='<img src="'+value[1]+'" class="uk-responsive-width uk-object-contain uk-align-center" style="width: 200px; height: 200px">';
                                break;
                        }

                        cardList+='<figcaption class="uk-text-meta uk-text-center"><p style="max-width: 200px"><strong>Nom&nbsp;:</strong> <span>'+value[2]+'</span></p><p style="max-width: 200px"><strong>Texte alternatif&nbsp;:</strong> <span>'+value[4]+'</span></p></figcaption></figure></div><input type="hidden" name="'+origin+'['+row+'][]" value="'+value[0]+'"></div>';

                        sortableList.innerHTML = sortableList.innerHTML + cardList;
                        UIkit.modal('#'+modal).hide()

                        let trashElements = document.querySelectorAll('.ltp_trashElement');
                        trashElements.forEach((trashElementEl)=>{
                            trashElementEl.addEventListener('click', ()=>{
                                trashElementEl.parentElement.remove();
                            })
                        })
                    }

                } else {
                    let inputName = '[name="'+input+'['+row+']'+(secrow.length!=0 ? '['+secrow+']':'')+'"]';
                    document.querySelector(inputName).value = parseInt(value[0]);
                    document.querySelector('.ltp_lightbox_'+input+(secrow.length!=0 ? '_'+secrow:'')).setAttribute('href',value[1]);
                    document.querySelector('.ltp_lightbox_'+input+(secrow.length!=0 ? '_'+secrow:'')).setAttribute('data-type',getLightBoxDataType(dataType));
                    document.querySelector('.'+origin).innerHTML = value[2];
                    document.querySelector('.'+origin).parentNode.classList.remove('uk-hidden');
                    document.querySelector('[data-origin="'+input+'"][data-row="'+row+'"]'+(secrow.length!=0 ? '[data-secrow="'+secrow+'"]':'')).classList.add('uk-hidden');
                    UIkit.modal('#'+origin).hide()
                }
            })
        });
    }

    if(document.querySelectorAll('.clearLinkMedia').length != 0)
    {
        var clearLinkMedia = document.querySelectorAll('.clearLinkMedia');
        clearLinkMedia.forEach((link)=>{
            link.addEventListener('click',()=>{
                let button = link.parentElement.parentElement.parentElement.parentElement.firstElementChild;
                let origin = button.dataset.origin;
                let row = button.dataset.row;
                let secrow = button.dataset.secrow;
                if(secrow == undefined){
                    secrow='';
                }
                let inputName = '[name="'+origin+'['+row+']'+(secrow.length!=0 ? '['+secrow+']':'')+'"]';
                document.querySelector(inputName).value = '';
                document.querySelector('.ltp_lightbox_'+origin+(secrow.length!=0 ? '_'+secrow:'')).setAttribute('href','');
                document.querySelector(inputName).parentNode.classList.add('uk-hidden');
                button.classList.remove('uk-hidden');
            })
        })
    }
}

export function getLightBoxDataType(dataType)
{
    switch (dataType)
    {
        case 'pdf':
            return 'iframe'
            break;

        case 'image':
        case 'video':
        default :
            return dataType
            break;

    }
}

/**
 * Reports a failed request, except an interrupted one (status 0: page left,
 * network or server unreachable) and the failure of a report itself,
 * which would report itself again in a loop.
 */
function reportFailure(xmlhttp, url)
{
    let logSendMeta = document.querySelector('[name="logSend"]');
    if(xmlhttp.status === 0 || (logSendMeta !== null && url === logSendMeta.getAttribute('content'))) {
        return;
    }
    logSend(xmlhttp);
}

export function logSend(logs)
{
    let logSend = document.querySelector('[name="logSend"]');
    if(logSend !== null) {
        let datas = new FormData();
        datas.set('status', logs.status)
        datas.set('statusText', logs.statusText)
        datas.set('responseURL', logs.responseURL)
        datas.set('responseText', logs.responseText)
        setAjax(logSend.getAttribute('content'),datas).then((response)=>{
            console.log(response)
        })
    }
}
